<div class="navigation flex-[85px] max-w-[85px]" (click)="moveContainer('left')">
  <mat-icon [ngClass]="canNotMoveLeft ? 'arrow-inactive' : 'arrow-active'">chevron_left</mat-icon>
</div>
<drag-scroll
  [scroll-x-wheel-enabled]="true"
  [scrollbar-hidden]="true"
  [drag-scroll-y-disabled]="true"
  #dragScroll
>
  <div
    *ngFor="let device of installationsStore.selectMainDevicesAndOrderTiles(installationId) | async"
    drag-scroll-item
  >
    <app-main-devices-tile
      [installationId]="installationId"
      [device]="device"
      [isDragging]="isDragging"
    ></app-main-devices-tile>
  </div>
</drag-scroll>
<div class="navigation flex-[85px] max-w-[85px]" (click)="moveContainer('right')">
  <mat-icon [ngClass]="canNotMoveRight ? 'arrow-inactive' : 'arrow-active'">chevron_right</mat-icon>
</div>
